<template>
    <div class="mehrfachbindung-nachweis">
        <ul>
            <li>elektrophile Addition</li>
            <li>z.B. Hexen + Brom</li>
            <li>ohne besondere Energiezufuhr</li>
            <li>Iodzahlermittlung (bes. bei ungesättigten Fetten)</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'mehrfachbindung-nachweis',
};
</script>
